module.exports = __webpack_public_path__ + "img/one_new.ce868fd3.png";